// extracted by mini-css-extract-plugin
module.exports = {"upload":"Upload_upload_2Cvy_","file":"Upload_file_EkxQo"};